import React from 'react';
import { View } from 'react-native';
import R from '../../core-res/R';
import DRNText from '../Text/DRNText';
import variants from './variants';
class DRNBadge extends React.Component {
    componentDidMount() {
        if (this.props.type) {
            console.warn('Using "type" props at Badge will be deprecated. Please use "variant" props instead');
        }
    }
    render() {
        const { label, type, variant } = this.props;
        const badgeStyle = variants[type || variant];
        return (<View style={styles(badgeStyle).container}>
        <DRNText style={styles(badgeStyle).label}>{label}</DRNText>
      </View>);
    }
}
const styles = badgeStyle => ({
    container: Object.assign({ borderRadius: 14, paddingVertical: R.spacing.xxs, paddingHorizontal: R.spacing.xs }, badgeStyle.containerStyle),
    label: Object.assign({}, badgeStyle.labelStyle, R.typography.uiTiny, { textAlign: 'center' }),
});
Object.keys(variants).forEach(variant => {
    DRNBadge[variant] = variant;
});
export default DRNBadge;
